import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=29ab84ca&scoped=true&"
import script from "./editService.vue?vue&type=script&lang=js&"
export * from "./editService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab84ca",
  null
  
)

export default component.exports